import './BudgetIcon.scss'

interface Props {
    budget: Budget | undefined
    color?: string
}

const BudgetIcon = (props: Props) => {
    const {budget, color} = props

    return <div
        className={`budget-icon fa-solid fa-${budget?.icon || 'question'}`}
        style={{color: color || budget?.color}}/>
}

export default BudgetIcon